const { validHashes, Vue } = window;

window.volReviewerGuide = new Vue({
  el: '#reviewer-guide',
  data: {
    current: 'overview',
    validHashes
  },
  methods: {
    getHashId(str) {
      var which = str.replace('#', '');
      return this.validHashes.includes(which) ? which : this.validHashes[0];
    },
    choose() {
      this.current = this.getHashId(window.location.hash);
    }
  },
  beforeMount() {
    this.choose();
  },
  mounted() {
    window.addEventListener('hashchange', this.choose);
  }
});
